export default "__VITE_ASSET__CV5A5HlX__"